import type { ReactNode } from 'react';
import { DialogDescription, DialogPortal, DialogRoot } from '../../../baseComponents/dialog';
import { DialogButton, DialogContentWrapper, DialogHeader, DialogOverlay } from './InformationPopUp.styles';

type InformationPopUpProps = {
  isOpen: boolean;
  message: string;
  description: string;
  confirmationLabel: string;
  confirmationText: ReactNode;
  onConfirm?: () => void;
  handleCloseOverlay?: () => void;
  handleOpenChange?: (open: boolean) => void;
  handleClose?: () => void;
};

export function InformationPopUp({
  isOpen,
  message,
  description,
  confirmationLabel,
  confirmationText,
  onConfirm,
  handleCloseOverlay,
  handleOpenChange,
  handleClose,
}: InformationPopUpProps) {
  const handleOnConfirm = () => {
    onConfirm?.();
    handleCloseOverlay?.();
  };
  return (
    <DialogRoot open={isOpen} onOpenChange={handleOpenChange}>
      <DialogPortal>
        <div data-focus-lock="cart-modals">
          <DialogOverlay>
            <DialogContentWrapper
              role="dialog"
              aria-labelledby="informationPopUpHeader"
              aria-describedby="informationPopUpDescription"
              isWithCloseButton
              onEscapeKeyDown={handleClose}
            >
              <DialogHeader id="informationPopUpHeader">{message}</DialogHeader>
              <DialogDescription id="informationPopUpDescription">{description}</DialogDescription>
              <DialogButton
                data-testid="informationPopUpButton"
                aria-label={confirmationLabel}
                onClick={handleOnConfirm}
              >
                {confirmationText}
              </DialogButton>
            </DialogContentWrapper>
          </DialogOverlay>
        </div>
      </DialogPortal>
    </DialogRoot>
  );
}
